import { KTX2Loader } from "three/examples/jsm/loaders/KTX2Loader.js";
import { WebGPURendererSingleton } from "../engine/renderer/WebGPURendererSingleton";

const TRANSCODER_PATH =
  "https://s3.eu-central-1.amazonaws.com/cdn.sugartech/mottobucket/ktx/";

/**
 * Shared KTX2Loader instance. Multiple active KTX2Loader instances cause
 * three.js to emit a performance warning and waste worker pools, so all
 * callers should reuse this single loader.
 *
 * detectSupport requires an initialized WebGPURenderer — call
 * {@link KTX2LoaderSingleton.ensureSupportDetected} before loading.
 */
export class KTX2LoaderSingleton {
  private static _instance: KTX2Loader;
  private static _detectPromise: Promise<void> | undefined;

  static getInstance(): KTX2Loader {
    if (!KTX2LoaderSingleton._instance) {
      KTX2LoaderSingleton._instance = new KTX2Loader().setTranscoderPath(
        TRANSCODER_PATH,
      );
    }
    return KTX2LoaderSingleton._instance;
  }

  /** Await WebGPURenderer.init() then run detectSupport once. */
  static async ensureSupportDetected(): Promise<void> {
    if (!KTX2LoaderSingleton._detectPromise) {
      KTX2LoaderSingleton._detectPromise = (async () => {
        const renderer = WebGPURendererSingleton.getInstance();
        await renderer.ensureReady();
        KTX2LoaderSingleton.getInstance().detectSupport(renderer.instance);
      })();
    }
    await KTX2LoaderSingleton._detectPromise;
  }
}
